import { Component, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { accountReviewKey } from '../account-review-detail-keys';
import { Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-account-history-dialog',
  templateUrl: './account-history-dialog.component.html',
  styleUrls: ['./account-history-dialog.component.scss'],
  imports: [MatDialogModule, MatButtonModule, MatIconModule, MatTooltipModule],
})
export class AccountHistoryDialogComponent {
  private router = inject(Router);
  dialogRef = inject<MatDialogRef<AccountHistoryDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  accountReviewKey = accountReviewKey;

  viewHistoryEvent(accountDetail) {
    this.router
      .navigate([`/account-review/${accountDetail.AccountID}`])
      .then(() => {
        window.location.reload();
      });
  }

  cancel() {
    this.dialogRef.close('cancel');
    this.dialogRef.afterClosed().subscribe(() => {
      this.dialogRef = null;
    });
  }
}
